module.exports = __webpack_public_path__ + "static/img/button.46c833e4.png";